import { api } from "@/lib/apiClient";

const KEY = "octon_brain_snapshot";

// Fetch brain state; on network failure fall back to the last cached snapshot.
export async function getBrainState() {
  try {
    const res = await api.get("/brain/state");
    localStorage.setItem(KEY, JSON.stringify({ data: res.data, ts: Date.now() }));
    return { data: res.data, offline: false };
  } catch (e) {
    const cached = localStorage.getItem(KEY);
    if (cached) {
      const parsed = JSON.parse(cached);
      return { data: parsed.data, offline: true, ts: parsed.ts };
    }
    return { data: null, offline: true };
  }
}
